
import { Base } from '../base-component';

import './additional-requirements.component.scss';

import { MediaQueryService } from '../../services/media-query.service';

export class AdditionalRequirements extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;
	currentStep: Element;
	formPageTotal: Number;
	currentPage: Element;
	nextButton: Element;
	prevButton: Element;
	resetButton: Element;
	submitButton: Element;

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {
		this.modals = Array.from(this.element.querySelectorAll('.js-add-req-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-add-req-modal-open'));
		this.closeButton = this.element.querySelector('.js-add-req-modal-close');
		this.currentPage = this.element.querySelector('.add-req__form-page--current');
		this.nextButton = this.element.querySelector('.js-add-req-next-step');
		this.prevButton = this.element.querySelector('.js-add-req-prev-step');
		this.resetButton = this.element.querySelector('.js-add-req-reset');
		this.submitButton = this.element.querySelector('.js-add-req-submit');
		this.formPageTotal = this.element.querySelectorAll('.add-req__form-page').length;
		this.currentStep = this.element.querySelector('.js-add-req-current-step');
	}

	bindEvents() {

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
        }));

		this.nextButton.addEventListener('click', (event) => this.pageNext(event));
		this.prevButton.addEventListener('click', (event) => this.pagePrev(event));
		this.resetButton.addEventListener('click', (event) => this.resetForm(event));

		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('orientationchange', this.onResize.bind(this));

	}

	onResize() {

		setTimeout(() => {
			this.adjustContentHeight();
		}, 100);

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {

		let modalId = event.target.getAttribute('data-modal');

		this.event.emit('openModal', {
			id: modalId
		});

	}

	closeModal() {

		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModal(event, data) {
		this.activeModal = this.getModalById(data.id);
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
		this.adjustContentHeight();
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

	adjustContentHeight() {

		let headerHeight = this.element.querySelector('.add-req__header').clientHeight;
		let footerHeight = this.element.querySelector('.add-req__footer').clientHeight;
		let containerHeight = this.element.querySelector('.add-req__modal-content').clientHeight;

		let newContentHeight = containerHeight - footerHeight - headerHeight;

		let content = this.element.querySelector('.add-req__content') as HTMLElement;

		if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

			if (newContentHeight > 1) {

				content.style.height = `${newContentHeight}px`;

			} else {

				setTimeout(() => {
					this.adjustContentHeight();
				}, 100);

			}

			content.style.marginBottom = `${footerHeight}px`;

		} else {

			content.style.height = 'auto';
			content.style.marginBottom = '0';

		}

	}

	pageNext(event) {

		event.preventDefault();

		if (!this.nextButton.classList.contains('button--disabled')) {

			let currentPageId = parseInt(this.currentPage.id.replace(/\D/g,''));
			let nextPageId = currentPageId + 1;
			let nextPage = this.element.querySelector('#p' + nextPageId);

			this.currentPage.classList.remove('add-req__form-page--current');
			this.currentPage.classList.remove('add-req__form-page--left');
			this.currentPage.classList.remove('add-req__form-page--right');

			nextPage.classList.add('add-req__form-page--current');
			nextPage.classList.add('add-req__form-page--right');

			if (nextPageId === this.formPageTotal) {

				this.disableNextButton();
				this.showResetButton();

				this.nextButton.classList.add('add-req__button--hidden');
				this.submitButton.classList.remove('add-req__button--hidden');

			}

			this.enablePrevButton();
			this.updateStepIndicator(nextPageId, currentPageId);

			this.currentPage = nextPage;

		}

	}

	pagePrev(event) {

		event.preventDefault();

		if (!this.prevButton.classList.contains('button--disabled')) {

			let currentPageId = parseInt(this.currentPage.id.replace(/\D/g,''));
			let prevPageId = currentPageId - 1;
			let prevPage = this.element.querySelector('#p' + prevPageId);

			this.currentPage.classList.remove('add-req__form-page--current');
			this.currentPage.classList.remove('add-req__form-page--left');
			this.currentPage.classList.remove('add-req__form-page--right');

			prevPage.classList.add('add-req__form-page--current');
			prevPage.classList.add('add-req__form-page--left');

			if (prevPageId === 1) {
				this.disablePrevButton();
			}

			this.submitButton.classList.add('add-req__button--hidden');
			this.nextButton.classList.remove('add-req__button--hidden');

			this.enableNextButton();
			this.hideResetButton();
			this.updateStepIndicator(prevPageId, currentPageId);

			this.currentPage = prevPage;

		}

	}

	pageStart() {

		let startPage = this.element.querySelector('#p1');
		let currentPageId = parseInt(this.currentPage.id.replace(/\D/g,''));

		this.currentPage.classList.remove('add-req__form-page--current');
		this.currentPage.classList.remove('add-req__form-page--left');
		this.currentPage.classList.remove('add-req__form-page--right');

		startPage.classList.add('add-req__form-page--current');
		startPage.classList.add('add-req__form-page--left');

		this.submitButton.classList.add('add-req__button--hidden');
		this.nextButton.classList.remove('add-req__button--hidden');

		this.disablePrevButton();
		this.enableNextButton();
		this.hideResetButton();
		this.updateStepIndicator(1, currentPageId);

		this.currentPage = startPage;

	}

	resetForm(event) {

		event.preventDefault();

		document.querySelector('form').reset();

		this.pageStart();

	}

	updateStepIndicator(newIndicator, oldIndicator) {

		this.element.querySelector('#i' + oldIndicator).classList.remove('add-req__steps-item--current');
		this.element.querySelector('#i' + newIndicator).classList.add('add-req__steps-item--current');

		this.updateStepText(newIndicator);

	}

	updateStepText(step) {
		this.currentStep.textContent = step;
	}

	disablePrevButton() {
		this.prevButton.classList.add('button--disabled');
	}

	enablePrevButton() {
		this.prevButton.classList.remove('button--disabled');
	}

	disableNextButton() {
		this.nextButton.classList.add('button--disabled');
	}

	enableNextButton() {
		this.nextButton.classList.remove('button--disabled');
	}

	showResetButton() {
		this.resetButton.classList.remove('add-req__reset--hidden');
	}

	hideResetButton() {
		this.resetButton.classList.add('add-req__reset--hidden');
	}

}



// WEBPACK FOOTER //
// ./components/additional-requirements/additional-requirements.component.ts